import { Component, Prop, Mixins } from 'vue-property-decorator';
import i18n from '@nodes/locales';

@Component
/**
 * BlogCard Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * ٍEnable more button
     */
    @Prop({ type: Boolean }) moreButton!: boolean;

    /**
     * More icon name
     */
    @Prop({ type: String, default: i18n.locale === 'en' ? 'arrow-right' : 'arrow-left' }) moreIcon!: string;

    /**
     * More Icon prefix
     */
    @Prop({ type: String, default: 'fas' }) moreIconPrefix!: string;

    /**
     * More Icon size
     */
    @Prop({ type: String, default: 'small' }) moreIconSize!: string;

    /**
     * Route Name
     */
    @Prop({ type: String, default: 'blog' }) routeName!: string;

    /**
     * Button title
     */
    @Prop({ type: String }) buttonTitle!: string;

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;
}
